import KnowledgeGraph from "./KnowledgeGraph";

export default KnowledgeGraph;
